import React from 'react';
import CalendarDayCell from './CalendarDayCell';
import { toISODate } from './calendarConstants';

const WEEKDAY_LABELS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// Plain Date math — 6 rows x 7 columns, always, so the grid height never
// jumps between months (a short 4-row month would otherwise reflow the
// whole page as you page through). Leading/trailing cells from the
// adjacent month are shown (greyed) rather than left blank, since an item
// dated on one of those days is still fetched (see DashboardCalendar's
// range calc) and needs somewhere to render.
export function getMonthGridRange(anchorDate) {
  const year = anchorDate.getFullYear();
  const month = anchorDate.getMonth();
  const firstOfMonth = new Date(year, month, 1);
  const gridStart = new Date(year, month, 1 - firstOfMonth.getDay());
  const gridEnd = new Date(gridStart.getFullYear(), gridStart.getMonth(), gridStart.getDate() + 41);
  return { gridStart, gridEnd };
}

function CalendarMonthGrid({ anchorDate, itemsByDate, dragProps }) {
  const { gridStart } = getMonthGridRange(anchorDate);
  const month = anchorDate.getMonth();
  const days = Array.from({ length: 42 }, (_, i) => new Date(gridStart.getFullYear(), gridStart.getMonth(), gridStart.getDate() + i));

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', marginBottom: 4 }}>
        {WEEKDAY_LABELS.map((label) => (
          <div key={label} style={{ fontSize: 11, fontWeight: 600, color: '#9aa5b5', textAlign: 'center', padding: '4px 0' }}>{label}</div>
        ))}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)' }}>
        {days.map((date) => (
          <CalendarDayCell
            key={toISODate(date)}
            date={date}
            items={itemsByDate[toISODate(date)] || []}
            inCurrentMonth={date.getMonth() === month}
            compact
            {...dragProps}
          />
        ))}
      </div>
    </div>
  );
}

export default CalendarMonthGrid;
